import { Hero } from "../../../common";

const VideoPlayerHeroTile = ({ bgImage }) => {
    return <Hero aspectRatio={{ base: 3 / 1, md: 7 / 1, lg: 5 / 1 }} bgImage={bgImage} />;
};

export default VideoPlayerHeroTile;
